module.exports = __webpack_public_path__ + "static/media/Feb_2026_5.4b71b5b9.webp";